import React from 'react'

interface FilterTagProps {
  column: string
  includeText?: string
  excludeText?: string
  value?: string
  onClose?: () => void
}

const FilterTag: React.FC<FilterTagProps> = ({
  column,
  includeText,
  excludeText,
  value,
  onClose,
}) => {
  const isTagColumn = column?.toLowerCase() === 'tags'
  return (
    <div
      className='d-inline-flex align-items-center border rounded px-3 py-2 me-2'
      style={{backgroundColor: '#F0F2F5'}}
    >
      {isTagColumn ? (
        <span className='me-2'>
          {column} : include <strong>{includeText ?? '—'}</strong> exclude{' '}
          <strong>{excludeText ?? '—'}</strong>
        </span>
      ) : (
        <span className='me-2'>
          <strong>
            {column} : {value && value.length > 50 ? value.substring(0, 50) + '...' : value ?? '—'}
          </strong>
        </span>
      )}

      <button
        type='button'
        className='btn-close'
        style={{width: '4px', height: '4px'}}
        aria-label='Close'
        onClick={onClose}
      ></button>
    </div>
  )
}

export default FilterTag
